import { PermissionsType } from '@/common/permissionsConst';
import { Themes } from '@maxtropy/components';
import Visualizations from '.';

const routes = [
  {
    path: '/system/setting/visualizations',
    permission: PermissionsType.P_EAMANAGEMENTOVERVIEW,
    theme: Themes.DARK,
    element: <Visualizations />,
  },
];

export default routes;
